import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "app-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppTitleBar = _resolveComponent("AppTitleBar")!
  const _component_SplashMenu = _resolveComponent("SplashMenu")!
  const _component_PageEditorControl = _resolveComponent("PageEditorControl")!
  const _component_ScrollBox = _resolveComponent("ScrollBox")!
  const _component_FileSelect = _resolveComponent("FileSelect")!
  const _component_AppMetricsBar = _resolveComponent("AppMetricsBar")!
  const _component_AppHotkeyBox = _resolveComponent("AppHotkeyBox")!

  return (_openBlock(), _createBlock(_component_AppHotkeyBox, { id: "main" }, {
    default: _withCtx(() => [
      _createVNode(_component_AppTitleBar, { id: "app-title-bar" }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ScrollBox, {
          id: "page-container",
          alwaysShowScrollBar: true
        }, {
          default: _withCtx(() => [
            (_ctx.editor.isPhantom())
              ? (_openBlock(), _createBlock(_component_SplashMenu, {
                  key: 0,
                  id: "splash-menu",
                  templates: _ctx.templates,
                  onNew: _ctx.onNewDocument,
                  onOpen: _ctx.onOpenDocument
                }, null, 8, ["templates", "onNew", "onOpen"]))
              : (_openBlock(), _createBlock(_component_PageEditorControl, {
                  key: 1,
                  id: "page",
                  page: _ctx.editor.page,
                  onExecute: _ctx.onExecute
                }, null, 8, ["page", "onExecute"]))
          ]),
          _: 1
        })
      ]),
      _withDirectives(_createVNode(_component_FileSelect, {
        id: "file-select",
        active: _ctx.editor.id,
        editors: _ctx.editors,
        onClose: _ctx.onEditorClose,
        onSwitch: _ctx.onEditorSwitch
      }, null, 8, ["active", "editors", "onClose", "onSwitch"]), [
        [_vShow, 0 < _ctx.editors.size]
      ]),
      _createVNode(_component_AppMetricsBar, { id: "metrics-bar" })
    ]),
    _: 1
  }))
}